import { Flags } from "@siteimprove/alfa-flags";
import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Slice } from "@siteimprove/alfa-slice";
import { Token } from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
import { Value } from "../value.js";
const { doubleBar, mapResult } = Parser;
const TFlags = Flags.named("trim", "discard-before", "discard-after", "discard-inner");
/**
 * @public
 */
export class TrimFlags extends Value {
    static of(flags) {
        return new TrimFlags(flags);
    }
    _flags;
    constructor(flags) {
        super("trim-flags", false);
        this._flags = flags;
    }
    get discardBefore() {
        return this._flags["discard-before"];
    }
    get discardAfter() {
        return this._flags["discard-after"];
    }
    get discardInner() {
        return this._flags["discard-inner"];
    }
    resolve() {
        return this;
    }
    equals(value) {
        return value instanceof TrimFlags && value._flags.equals(this._flags);
    }
    hash(hash) {
        hash.writeNumber(this._flags.value);
    }
    toJSON() {
        const { discardBefore, discardAfter, discardInner } = this;
        return {
            ...super.toJSON(),
            "discard-after": discardAfter,
            "discard-before": discardBefore,
            "discard-inner": discardInner,
        };
    }
    toString() {
        return this._flags.toString();
    }
}
/**
 * @public
 */
(function (TrimFlags) {
    function isTrimFlags(value) {
        return value instanceof TrimFlags;
    }
    TrimFlags.isTrimFlags = isTrimFlags;
    TrimFlags.parse = mapResult(doubleBar(Token.parseWhitespace, Keyword.parse("discard-before"), Keyword.parse("discard-after"), Keyword.parse("discard-inner")), (flags) => {
        if (flags.every((flag) => flag === undefined)) {
            return Err.of("Expected at least one trim flag");
        }
        return Result.of(TrimFlags.of(TFlags.of(...flags.map((flag) => flag?.value ?? 0))));
    });
})(TrimFlags || (TrimFlags = {}));
//# sourceMappingURL=trim.js.map